import {mapToFlatListWithKey, WithChildren} from '@hconnect/common/utils'
import moment from 'moment-timezone'

export const tableCellDataTestIdGenerator = (id: string, columnKey: string) =>
  `table-cell-${id}-${columnKey}`

export const getAllItemIds = <K extends keyof T, T extends WithChildren<T, K> & {id: string}>(
  childrenKey: K,
  data: T[]
): string[] => {
  return mapToFlatListWithKey(childrenKey, data ?? []).map((entry) => entry.id)
}
export const getMonthsDetails = (language: string) => {
  const monthsNumbers = Array.from({length: 12}, (_, i) => i + 1)
  const monthsNames = monthsNumbers.map((month) =>
    moment()
      .month(month - 1)
      .locale(language)
      .format('MMMM')
  )

  return {numbers: monthsNumbers, names: monthsNames}
}

export const getDaysDetails = (date: Date, language: string): string[] => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const daysInMonth = new Date(year, month + 1, 0).getDate()

  const weekdayFormatter = new Intl.DateTimeFormat(language, {weekday: 'short'})
  const monthNum = String(month + 1).padStart(2, '0')

  return Array.from({length: daysInMonth}, (_, i) => {
    const day = new Date(year, month, i + 1)
    const weekday = weekdayFormatter.format(day)
    const weekdayLabel = weekday.charAt(0).toUpperCase() + weekday.slice(1)
    return `${i + 1}.${monthNum} (${weekdayLabel})`
  })
}
